/* eslint-disable no-unused-vars */
import { isNonEmptyArray } from '@/helpers/array-helpers'
import dayjs from '@/services/date/index'
import ShiftRecordBreakDto from '../shiftRecords/shiftRecordBreakDto'
import CandidateTimesheetModificationsViewModel from './candidateTimesheetModificationsViewModel'

export default class TimesheetsPendingApprovalViewModel {
  constructor({
    locationId = 0,
    locationName,
    locationTimeZone,
    clientId = 0,
    clientName,
    clientGroupId = 0,
    payOptionType,
    payOptionTypes = [],
    unitType,
    bookingId = 0,
    startTimeLocal,
    endTimeLocal,
    startTimeUTC,
    endTimeUTC,
    candidateId = 0,
    candidateFirstName,
    candidateLastName,
    candidatePreferredName,
    candidateFullName,
    breakMinutes = 0,
    isApprovedByCandidate = true,
    breaks = [],
    timesheetMethod,
    bookingStatus,
    candidateBookingModifications,
  } = {}) {
    /**
     * @type {Number}
     */
    this.locationId = locationId

    /**
     * @type {String}
     */
    this.locationName = locationName

    /**
     * @type {String}
     */
    this.locationTimeZone = locationTimeZone

    /**
     * @type {Number}
     */
    this.clientId = clientId

    /**
     * @type {String}
     */
    this.clientName = clientName

    /**
     * @type {Number}
     */
    this.clientGroupId = clientGroupId

    /**
     * @type {String}
     */
    this.payOptionType = payOptionType

    /**
     * @type {Array<String>}
     */
    this.payOptionTypes = isNonEmptyArray(payOptionTypes) ? payOptionTypes : []

    /**
     * @type {String}
     * @see {RateUnitType} for valid range of values
     */
    this.unitType = unitType

    /**
     * @type {Number}
     */
    this.bookingId = bookingId

    /**
     * @type {Date}
     */
    this.startTimeLocal = startTimeLocal ? dayjs(startTimeLocal) : null

    /**
     * @type {Date}
     */
    this.endTimeLocal = endTimeLocal ? dayjs(endTimeLocal) : null

    /**
     * @type {Date}
     */
    this.startTimeUTC = startTimeUTC ? dayjs.utc(startTimeUTC) : null

    /**
     * @type {Date}
     */
    this.endTimeUTC = endTimeUTC ? dayjs.utc(endTimeUTC) : null

    /**
     * @type {Number}
     */
    this.candidateId = candidateId

    /**
     * @type {String}
     */
    this.candidateFirstName = candidateFirstName

    /**
     * @type {String}
     */
    this.candidateLastName = candidateLastName

    /**
     * @type {String}
     */
    this.candidatePreferredName = candidatePreferredName

    /**
     * @type {String}
     */
    this.candidateFullName = candidateFullName

    /**
     * @type {Number}
     */
    this.breakMinutes = breakMinutes

    /**
     * @type {Boolean}
     */
    this.isApprovedByCandidate = isApprovedByCandidate

    /**
     * @type {Array<ShiftRecordBreakDto>}
     */
    this.breaks = isNonEmptyArray(breaks)
      ? breaks.map((breakTaken) => new ShiftRecordBreakDto(breakTaken))
      : []

    /**
     * @type {String}
     * @see {TimesheetMethod} for valid range of values
     */
    this.timesheetMethod = timesheetMethod

    /**
     * @type {Number}
     * @see {BookingStatus} for valid range of values
     */
    this.bookingStatus = bookingStatus

    /**
     * @type {CandidateTimesheetModificationsViewModel}
     */
    this.candidateBookingModifications = candidateBookingModifications
  }
}
